var render = function render(){var _vm=this,_c=_vm._self._c;return _c('doctor-schedule',{attrs:{"doctor":_vm.doctor},on:{"update":_vm.onUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }